import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '@formosa/shared/api/admin';
import Pagination from '../../components/Pagination';
import ReactionPackEditModal from './ReactionPackEditModal';
import {
  PACK_STATUS_OPTIONS,
  buildReactionPackPageParams,
  formatPackStatus,
} from './reactionConstants';

const EMPTY_FILTERS = { status: '', name: '' };

export default function ReactionPackPage() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [editOpen, setEditOpen] = useState(false);
  const [editId, setEditId] = useState(null);

  async function loadRecords(pageNo = 1, nextFilters = filters) {
    setLoading(true);
    setError('');
    try {
      const data = await adminApi.imReactionPackPageQuery(
        buildReactionPackPageParams(pageNo, nextFilters)
      );
      setRecords(data?.records || []);
      setPage(data?.current || pageNo);
      setTotalPages(data?.pages || 1);
      setTotal(data?.total ?? 0);
    } catch (err) {
      setError(err.message || '載入失敗');
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRecords(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-card">
      <div className="section-header">
        <h2>回覆表情包</h2>
        <div className="section-header__actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setEditId(null);
              setEditOpen(true);
            }}
          >
            新增
          </button>
        </div>
      </div>

      <form
        className="filter-bar"
        onSubmit={(e) => {
          e.preventDefault();
          loadRecords(1, filters);
        }}
      >
        <label>
          狀態
          <select
            value={filters.status}
            onChange={(e) => setFilters((p) => ({ ...p, status: e.target.value }))}
          >
            {PACK_STATUS_OPTIONS.map((opt) => (
              <option key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </label>
        <label>
          名稱
          <input
            value={filters.name}
            onChange={(e) => setFilters((p) => ({ ...p, name: e.target.value }))}
            placeholder="搜尋包名"
          />
        </label>
        <button type="submit" className="btn btn-secondary">
          查詢
        </button>
      </form>

      {error ? <p className="form-error">{error}</p> : null}
      {message ? <p className="form-success">{message}</p> : null}

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>圖示</th>
              <th>名稱</th>
              <th>Access</th>
              <th>狀態</th>
              <th>表情數</th>
              <th>排序</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7}>載入中…</td>
              </tr>
            ) : records.length ? (
              records.map((row) => (
                <tr key={row.id}>
                  <td>{row.coverEmoji || '—'}</td>
                  <td>{row.name}</td>
                  <td>{row.accessType}</td>
                  <td>{formatPackStatus(row.status)}</td>
                  <td>{row.emojiCount ?? 0}</td>
                  <td>{row.sort ?? 0}</td>
                  <td className="table-actions">
                    <button type="button" className="btn-link" onClick={() => {
                      setEditId(row.id);
                      setEditOpen(true);
                    }}>
                      編輯
                    </button>
                    <button
                      type="button"
                      className="btn-link"
                      onClick={() =>
                        navigate(`/system/sticker-manage/reaction/emojis?packId=${row.id}`)
                      }
                    >
                      表情
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7}>無資料</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        page={page}
        totalPages={totalPages}
        total={total}
        onChange={(p) => loadRecords(p)}
      />

      <ReactionPackEditModal
        open={editOpen}
        packId={editId}
        onClose={() => setEditOpen(false)}
        onSaved={(isEdit) => {
          setMessage(isEdit ? '修改成功' : '新增成功');
          loadRecords(page);
        }}
      />
    </div>
  );
}
